_ = require 'underscore'

# Returns a copy of the collection without the element which has an id
# that matches toRemove
module.exports = (collection, toRemove) ->
  _.reject (collection), (item) -> item.id == toRemove.id



// WEBPACK FOOTER //
// ./app/scripts/lib/util/array/remove-by-id.coffee